export let AppConnectionStatuses;
(function (AppConnectionStatuses) {
  AppConnectionStatuses["CONNECTION_LOST"] = "connection_lost";
  AppConnectionStatuses["DISCONNECTED"] = "disconnected";
  AppConnectionStatuses["NEEDS_REAUTHORIZATION"] = "needs_reauthorization";
  AppConnectionStatuses["NEW_FEATURES_AVAILABLE"] = "new_features_available";
  AppConnectionStatuses["NO_STATUS_AVAILABLE"] = "no_status_available";
  AppConnectionStatuses["OK"] = "ok";
  AppConnectionStatuses["SYNC_ERROR"] = "sync_error";
  AppConnectionStatuses["SUNSET"] = "sunset";
  AppConnectionStatuses["UPCOMING_SUNSET"] = "upcoming_sunset";
  AppConnectionStatuses["UPDATE_AVAILABLE"] = "update_available";
  AppConnectionStatuses["UPGRADE_AVAILABLE"] = "upgrade_available";
})(AppConnectionStatuses || (AppConnectionStatuses = {}));